/**
 * File entity validation rules.
 */

import { getEntityAttrString } from './ReusableValidation';
import type { ValidationWarning } from './ReusableValidation';

/** MIME/content type values that indicate text content; File entities should prefer Content entity for these. */
const TEXT_CONTENT_TYPES = new Set([
    'text/css', 'text/html', 'text/markdown', 'text/yaml',
    'application/x-yaml', 'application/yaml',
    'css', 'html', 'markdown', 'yaml', 'yml'
]);

const FILE_TEXT_CONTENT_TYPE_WARNING =
    'Text content types (CSS, HTML, Markdown, YAML) are intended for Content entities, not File entities. Consider using a Content entity instead for text-based content.';

/**
 * Returns validation warnings for File entity data.
 */
export function getFileWarnings(data: Record<string, any>): ValidationWarning[] {
    const warnings: ValidationWarning[] = [];
    const contentType = getEntityAttrString(data, 'ContentType').toLowerCase();
    if (contentType && TEXT_CONTENT_TYPES.has(contentType)) {
        warnings.push({
            message: FILE_TEXT_CONTENT_TYPE_WARNING,
            severity: 'warning',
            attributeDisplayNames: ['ContentType']
        });
    }
    return warnings;
}
